import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetailContext';

import { SkinAnalyzerConfig } from '../model';

export const useSkinAnalyzerBrandData = (): SkinAnalyzerConfig => {
  const { product } = useProductDetailContext(false);

  return {
    ...(product.features.skinAnalyzer as NonNullable<
      typeof product.features.skinAnalyzer
    >),
    brandName: product.brand?.name ?? '',
  };
};
